import { lazy } from "react";

const ConfiguracionLayout = lazy(() =>
      import("../../configuracion/Home.jsx")
);


const configuracionRoutes = [
      {
            path: "configuracion",
            element: <ConfiguracionLayout />
      },
];

export default configuracionRoutes;